import { render } from "./profit-and-loss.vue?vue&type=template&id=27926357"
import script from "./profit-and-loss.vue?vue&type=script&lang=js"
export * from "./profit-and-loss.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__